import {sentryCaptureMessageFiltered} from '@src/utility/sentry'

import {EVENT_TAGS} from '../type'
import {LoggerStrategyConstructor, LoggerStrategyType, LoggerUser} from './type'

export class LoggerStrategy {
  private readonly logStrategies: LoggerStrategyType[]

  constructor(logStrategies: LoggerStrategyConstructor[]) {
    this.logStrategies = logStrategies.filter(logger => logger.enabled).map(logger => logger.class)
  }

  async init() {
    await Promise.all(this.logStrategies.map(strategy => strategy.init?.()))
  }

  event<T extends keyof EVENT_TAGS>(name: T, properties?: EVENT_TAGS[T]) {
    try {
      this.logStrategies.forEach(strategy => strategy.event?.(name, properties))
    } catch (e) {
      sentryCaptureMessageFiltered(e as Error, 'LoggerStrategy event error')
    }
  }

  setUser(properties: LoggerUser) {
    if (!properties) return

    this.logStrategies.forEach(strategy => strategy.setUser?.(properties))
  }
}
